<template lang="pug">
v-container(fluid class="tw-px-0 tw-mx-0 tw-mt-0 tw-pt-0 tw-content-start ")
  v-row(no-gutters)
    v-col(cols="stretch")
      v-row(no-gutters)
        v-col
          span(class=" tw-font-bold") {{ opportunity.name }}
    v-col(cols="auto")
      v-row(no-gutters)
        v-col
          v-menu(offset-y nudge-left="40" dark class="tw-mx-0 tw-px-0")
            template(v-slot:activator="{ on, attrs }")
              v-btn(
                :ripple="false"
                depressed
                v-on="on"
                v-bind="attrs"
                width="10px"
                max-width="10"
                min-width="10"
                min-height="10"
                max-height="30"
                class="tw-border-gray-lighten-1 tw-p-0 tw-m-0"
              )
                v-icon(color="blue-grey darken-1 tw-p-0 tw-m-0") mdi-chevron-down
            v-list(dense)
              v-list-item(class="tw-px-0")
                v-btn(@click="edit" text block class="my-0")
                  v-row(no-gutters class="tw-cursor-pointer")
                    v-col(cols="auto")
                      span Edit

  v-row(no-gutters)
    v-col(class="tw-py-0 tw-my-0")
      v-divider
  v-row
    v-col
      div
        span(class="tw-font-bold tw-text-sm") Description
      div(class="tw-pt-1")
        span {{ opportunity.description }}
  v-row
    v-col
      div
        span(class="tw-font-bold tw-text-sm") Looking for
      div(class="tw-pt-1 tw-text-left")
        kubiqa-misc-tag(v-for="a in 10" :key="a.id" class="")
  v-row
    v-col
      div
        span(class="tw-font-bold tw-text-sm") Budget
      div(class="tw-pt-1")
        v-row(no-gutters align="center")
          v-col(cols="auto")
            span(class=" tw-text-indigo-lighten-1 tw-font-bold ") {{ this.$formatters.formatValue(opportunity.budget_min) }}
          v-col(cols="stretch mx-1")
            v-divider
          v-col(cols="auto")
            span(class=" tw-text-indigo-lighten-1 tw-font-bold ") {{ this.$formatters.formatValue(opportunity.budget_max) }}
  v-row
    v-col
      div
        span(class="tw-font-bold tw-text-sm") Decision by
      div(class="tw-pt-1")
        v-chip(label outlined color=" grey lighten-3")
          v-icon(small color="grey lighten-1") mdi-calendar
          span(class="pl-1 tw-text-sm tw-font-bold tw-text-gray-darken-2") {{ this.$moment(opportunity.expected_close_date).format('LL') }}

  v-row
    v-col(cols="12" class=" tw-mb-40")
      div
        span(class="tw-font-bold tw-text-sm") Assigned to
      div(class="tw-pt-1")
        kubiqa-misc-assign-user(item_type="opportunities" :key="key" :item="opportunity")
  v-dialog(v-model="editDialog" max-width="75%" class="tw-ml-32")
    div(class="tw-bg-white edit-opp-modal")
      kubiqa-opportunities-edit-main(:key="key" @close="editDialogToggle")
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      editDialog: false,
      key: 1,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    opportunity() {
      return this.$store.getters['opportunities/current_opportunity'];
    },
  },
  mounted: function () {
    this.loading = true;
    this.$store
      .dispatch('opportunities/view', this.id)
      .then((response) => {
        this.loading = false;
        this.key++;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  methods: {
    edit() {
      this.key++;
      this.editDialog = true;
    },
    editDialogToggle() {
      this.editDialog = false;
    },
  },
};
</script>
<style scoped>
.edit-opp-modal {
  height: 80vh !important;
  max-height: 600px;
}
</style>
